// Import model
import { FilterCustomerRequest } from '../models/FilterCustomerRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { CustomerCondition } from '../models/CustomerCondition';
import { CustomerFields } from '../models/CustomerFields';
import { CustomerIndexedFields } from '../models/CustomerIndexedFields';

// Import dependency serializers (for complex types)
import { CustomerConditionSerializer } from './CustomerConditionSerializer';
import { CustomerFieldsSerializer } from './CustomerFieldsSerializer';
import { CustomerIndexedFieldsSerializer } from './CustomerIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterCustomerRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterCustomerRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterCustomerRequest instance
   */
  static deserialize(json: string): FilterCustomerRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterCustomerRequest instance
   */
  static fromObject(obj: any): FilterCustomerRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterCustomerRequest');
    }


    const instance: FilterCustomerRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as CustomerIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as CustomerFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        CustomerConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterCustomerRequest instances
   */
  static deserializeArray(json: string): FilterCustomerRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterCustomerRequest instance to a JSON string
   */
  static serialize(instance: FilterCustomerRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterCustomerRequest instance to a plain object
   */
  static toObject(instance: FilterCustomerRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        CustomerConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterCustomerRequest instances to a JSON string
   */
  static serializeArray(instances: FilterCustomerRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
